/**
 * Human-readable remaining duration until picks lock (without trailing phrase).
 * @param {number} msRemaining
 * @returns {string | null} null when already locked / non-positive
 */
export function formatPicksLockDuration(msRemaining) {
  const ms = Number(msRemaining);
  if (!Number.isFinite(ms) || ms <= 0) return null;

  const totalMins = Math.floor(ms / 60000);
  if (totalMins < 1) return 'Less than a minute';

  const days = Math.floor(totalMins / (60 * 24));
  const hours = Math.floor((totalMins % (60 * 24)) / 60);
  const mins = totalMins % 60;

  const parts = [];
  if (days > 0) parts.push(`${days} ${days === 1 ? 'day' : 'days'}`);
  if (hours > 0) parts.push(`${hours} ${hours === 1 ? 'hour' : 'hours'}`);
  if (days === 0 && mins > 0) parts.push(`${mins} ${mins === 1 ? 'min' : 'mins'}`);
  if (parts.length === 0) return 'Less than a minute';

  return parts.join(' ');
}

/**
 * Human-readable remaining time until picks lock.
 * @param {number} msRemaining
 * @returns {string | null} null when already locked / non-positive
 */
export function formatPicksLockRemaining(msRemaining) {
  const duration = formatPicksLockDuration(msRemaining);
  if (!duration) return null;
  return `${duration} left to save picks`;
}

/**
 * Absolute lock time for tooltips, using the viewer's locale.
 * @param {number} lockMs
 * @param {Intl.DateTimeFormatOptions} [options]
 * @returns {string}
 */
export function formatPicksLockExactTime(lockMs, options) {
  return new Date(lockMs).toLocaleString(undefined, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    ...options
  });
}
